export default "__VITE_ASSET__D3eatU14__"